import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ThumbsUp, ThumbsDown, Check } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const QuickFeedback = ({ itemId, page, itemType = 'content' }) => {
  const [feedback, setFeedback] = useState(null); // 'helpful' or 'not-helpful'
  const [submitting, setSubmitting] = useState(false);

  const handleFeedback = async (isHelpful) => {
    setSubmitting(true);
    try {
      await axios.post(
        `${API}/feedback/submit`,
        {
          type: 'quick_feedback',
          page,
          item_id: itemId,
          helpful: isHelpful,
        },
        { withCredentials: true }
      );

      setFeedback(isHelpful ? 'helpful' : 'not-helpful');
      toast.success(
        isHelpful
          ? '👍 Thanks! Glad this was helpful.'
          : '👎 Thanks for letting us know. We\'ll improve this.'
      );
    } catch (error) {
      console.error('Error submitting quick feedback:', error);
      toast.error('Failed to submit feedback');
    } finally {
      setSubmitting(false);
    }
  };

  if (feedback) {
    return (
      <div className="flex items-center gap-2 text-sm text-healthloop-mint-700">
        <Check className="h-4 w-4" />
        <span>Thank you for your feedback!</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-600">Was this helpful?</span>
      <div className="flex gap-1">
        <Button
          onClick={() => handleFeedback(true)}
          disabled={submitting}
          variant="outline"
          size="sm"
          className="h-8 px-3 hover:bg-green-50 hover:border-green-300"
        >
          <ThumbsUp className="h-3.5 w-3.5" />
        </Button>
        <Button
          onClick={() => handleFeedback(false)}
          disabled={submitting}
          variant="outline"
          size="sm"
          className="h-8 px-3 hover:bg-red-50 hover:border-red-300"
        >
          <ThumbsDown className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  );
};

export default QuickFeedback;
